const prefixes = {
  clinics: 'clinic',
  services: 'service',
  products: 'product',
  articles: 'article',
  orders: 'order',
  CallBack: 'callback',
  ContactMessages: 'contact-message',
  seoScripts: 'script',
  serviceCategories: 'cat-service',
  productCategories: 'cat-product',
  articleCategories: 'cat-article'
}

let lastTimestamp = 0
let sameTimestampIndex = 0

export function getEntityPrefix(type) {
  return prefixes[type] || type || 'item'
}

export function createEntityId(type) {
  const timestamp = Date.now()
  const suffix = timestamp === lastTimestamp ? `-${++sameTimestampIndex}` : ''
  lastTimestamp = timestamp
  if (!suffix) sameTimestampIndex = 0
  return `${getEntityPrefix(type)}-${timestamp}${suffix}`
}

export function createNestedId(parentId, groupKey) {
  return createEntityId(`${parentId}-${groupKey}`)
}
